/* tslint:disable */
import {
  Account
} from '../index';

declare var Object: any;
export interface VoucherInterface {
  "code"?: string;
  "id"?: number;
  "accountId"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  account?: Account;
}

export class Voucher implements VoucherInterface {
  "code": string;
  "id": number;
  "accountId": number;
  "createdAt": Date;
  "updatedAt": Date;
  account: Account;
  constructor(data?: VoucherInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Voucher`.
   */
  public static getModelName() {
    return "Voucher";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Voucher for dynamic purposes.
  **/
  public static factory(data: VoucherInterface): Voucher{
    return new Voucher(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Voucher',
      plural: 'Vouchers',
      path: 'Vouchers',
      idName: 'id',
      properties: {
        "code": {
          name: 'code',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "accountId": {
          name: 'accountId',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        account: {
          name: 'account',
          type: 'Account',
          model: 'Account',
          relationType: 'belongsTo',
                  keyFrom: 'accountId',
          keyTo: 'id'
        },
      }
    }
  }
}
